import { RootState } from "../../rootReducer";

export const selectIsSavingSchedule = (state: RootState) => state.saveSchedule;
export const selectIsSaved = (state: RootState) => state.saveSchedule.saved;
export const selectSaveErrorMessage = (state: RootState) =>
  state.saveSchedule.error;
export const CreateScheduleDataResponse = (state: RootState) =>
  state.saveSchedule.saveScheduleResponse;
